import { useTranslation } from "react-i18next";
import { AdminCompanyListItem, Company } from "@/types";
import { Grid } from "@mantine/core";
import Text from "@/components/atoms/Text";

interface AMLandKYCTabProps {
  company: Company;
  adminCompanyListItem: AdminCompanyListItem | null;
}

export default function AMLandKYCTab({ company, adminCompanyListItem }: AMLandKYCTabProps) {
  const { t } = useTranslation();

  return (
    <>
      <Grid p="lg">
        <Grid.Col span={4}>
          <Text color="secondary" size="sm">
            {t("commonAdmin:risk")}
          </Text>
        </Grid.Col>
        <Grid.Col span={8}>
          <Text size="sm">{adminCompanyListItem?.companyRisk}</Text>
        </Grid.Col>

        <Grid.Col span={4}>
          <Text color="secondary" size="sm">
            {t("commonAdmin:complianceStatus")}
          </Text>
        </Grid.Col>
        <Grid.Col span={8}>
          <Text size="sm">{adminCompanyListItem?.complianceStatus}</Text>
        </Grid.Col>
      </Grid>
    </>
  );
}
